import clsx from 'clsx';
import { LuRotateCw } from 'react-icons/lu';
import { RoundButton, RoundButtonProps } from './RoundButton';

export const RoundRefreshButton = ({
  size = 'md',
  ...props
}: RoundButtonProps) => (
  <RoundButton size={size} {...props}>
    <LuRotateCw
      className={clsx(
        size === 'sm' && 'text-4xl',
        size === 'md' && 'text-6xl',
        size === 'lg' && 'text-8xl',
      )}
    />
  </RoundButton>
);
